export const LangValidation = {
    "accepted": "This field value must be accepted.",
    "date": "This field value is not a valid date.",
    "email": "This field value must be a valid email address.",
    "image": "This field value must be an image.",
    "max": "This field value is to long.",
    "min": "This field value is too short.",
    "numeric": "This field value must be a number.",
    "regex": "This field value format is invalid.",
    "required": "This field is required.",
    "same": "This field value and password must match.",
    "unique": "This field value has already been taken.",
    "exists_code": "This code is not valid.",
    "expire_code": "This code was expired",
    "used": "This code was used before.",
    "recaptcha": "This captcha is not valid.",
    "mime_type": "This field value must be a file of type: jpeg, png, gif",
    "national_id": "The National Id Must be 10 digits",
    "adult_age": "Adult age must be greater-than 12",
    "child_age": "Child age must be between 2 and 12",
    "infant_age": "Infant age must be less than 2"
};


// WEBPACK FOOTER //
// ./src/lang/en/validation.js